import { HttpInterceptorFn } from '@angular/common/http';
import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { isApiRequest } from '../utils/is-api-request';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  // Jamais attacher le token à autre chose que notre propre API — voir isApiRequest. Avant ce
  // garde-fou, il partait sur CHAQUE requête HTTP de l'app, y compris les bundles /i18n/*.json.
  if (!isApiRequest(req.url) || req.url.includes('/analytics-service/api/v1/public/traffic/')) return next(req);

  const token = isBrowser ? localStorage.getItem('ycc_access_token') : null;
  if (!token) return next(req);

  return next(
    req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
  );
};
